import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetChainReleaseOptions = (
  context: ProductBuilderMachineContext,
) => string[];

export const getChainReleaseOptions: GetChainReleaseOptions = context => {
  let options: string[] = [];
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];
  const {
    metafields: { chain_release },
  } = baseProduct;

  if (typeof chain_release === 'string') {
    options = JSON.parse(chain_release);
  } else {
    options = chain_release ? chain_release : [];
  }

  return options ? options : [];
};
